export { default as ChangePassword} from './ChangePassword'